const getFeaturedOffers = state => state?.featuredOffers?.featuredOffers;
const getFeaturedOffersStatus = state => state?.featuredOffers?.status;
const getSingleFeaturedOffer = state => state?.featuredOffers?.singleFeaturedOffer;
const getErrors = state => state?.featuredOffers?.error;

export { getFeaturedOffers, getFeaturedOffersStatus, getSingleFeaturedOffer, getErrors };
